"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKLayoutShellManager = void 0;
var react_1 = __importDefault(require("react"));
var GKLayoutShellContext_1 = require("./GKLayoutShellContext");
var __1 = require("../../");
/**
 * Manages context for the layout shell.
 * Currently handles navigation expansion state, but in the future
 * may be EXPANDED (heh) to handle more things. Uses the useDeviceSizes hook,
 * so needs to be within a WindowSizeManager
 */
var GKLayoutShellManager = function (_a) {
    var expansionCallback = _a.expansionCallback, children = _a.children;
    // Watch mobile size changes, because we have different initial expansion
    // states for mobile and tablet+
    var isMobileSized = (0, __1.useDeviceSizes)().isMobileSized;
    // Store nav expansion state.
    // Defaults to collapsed for mobile, expanded for tablet+
    var _b = react_1.default.useState(!isMobileSized), navExpanded = _b[0], setNavExpanded = _b[1];
    // Change expansion state when going from mobile to tablet+ (and vice versa)
    react_1.default.useEffect(function () {
        setNavExpanded(isMobileSized ? false : true);
    }, [isMobileSized, setNavExpanded]);
    // Handle any callback provided by the user
    react_1.default.useEffect(function () {
        expansionCallback === null || expansionCallback === void 0 ? void 0 : expansionCallback(navExpanded ? "expanded" : "collapsed");
    }, [expansionCallback, navExpanded]);
    return (react_1.default.createElement(GKLayoutShellContext_1.GKLayoutShellContext.Provider, { value: {
            isNavExpanded: navExpanded,
            setNavExpanded: setNavExpanded,
        } }, children));
};
exports.GKLayoutShellManager = GKLayoutShellManager;
